import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import ListingDetail from "@/pages/ListingDetail";
import PlaceAd from "@/pages/PlaceAd";
import Chats from "@/pages/Chats";
import ChatView from "@/pages/ChatView";
import Profile from "@/pages/Profile";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import PaymentStatus from "@/pages/PaymentStatus";
import Admin from "@/pages/Admin";
import { Voorwaarden, Privacy, Cookies, VeiligHandelen, FAQ, Contact } from "@/pages/StaticPages";
import { VersionChecker } from "@/components/VersionChecker";

function App() {
  return (
    <div className="App min-h-screen bg-[#111]">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/zoeken" element={<Browse />} />
              <Route path="/advertentie/:id" element={<ListingDetail />} />
              <Route path="/inloggen" element={<Login />} />
              <Route path="/registreren" element={<Register />} />
              <Route path="/wachtwoord-vergeten" element={<ForgotPassword />} />
              <Route path="/wachtwoord-reset" element={<ResetPassword />} />
              <Route path="/verifieer" element={<VerifyEmail />} />
              <Route path="/betaling/status" element={<PaymentStatus />} />
              <Route path="/voorwaarden" element={<Voorwaarden />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/veilig-handelen" element={<VeiligHandelen />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/plaatsen" element={<ProtectedRoute><PlaceAd /></ProtectedRoute>} />
              <Route path="/chats" element={<ProtectedRoute><Chats /></ProtectedRoute>} />
              <Route path="/chats/:id" element={<ProtectedRoute><ChatView /></ProtectedRoute>} />
              <Route path="/profiel" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            </Routes>
          </main>
          <Toaster theme="dark" position="top-center" richColors />
          <VersionChecker />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
